import type { ScopeOption } from 'src/utils/searchSchemas';

type ItemType = 'asset' | 'collection.gallery';

export const scopeToItemType = (scope?: ScopeOption): ItemType | undefined => {
  if (scope === 'assets') return 'asset';
  if (scope === 'galleries') return 'collection.gallery';
  return undefined;
};

export const fieldScopeToItemType = (fieldScope?: string[]): ItemType | undefined => {
  if (!fieldScope || fieldScope.length === 0) {
    return undefined;
  }

  const hasAsset = fieldScope.includes('asset');
  const hasGallery = fieldScope.includes('collection.gallery');

  // Only force item_type when a field is scoped to exactly one entity kind.
  // For mixed-scope fields, return undefined so facets include both assets
  // and galleries in "all" scope.
  if (hasAsset && !hasGallery) return 'asset';
  if (hasGallery && !hasAsset) return 'collection.gallery';
  return undefined;
};

export const matchesFieldScope = (fieldScope: string[] | undefined, scope?: ScopeOption): boolean => {
  if (!fieldScope || !Array.isArray(fieldScope)) {
    return true;
  }

  if (scope === 'assets') {
    return fieldScope.includes('asset');
  }

  if (scope === 'galleries') {
    return fieldScope.includes('collection.gallery');
  }

  return fieldScope.includes('asset') || fieldScope.includes('collection.gallery');
};
